import { Icon } from "./Icon.tsx";

/** Sun-behind-cloud, distinct from SnowIcon.tsx's plain snowflake. */
export function ClimateIcon() {
  return (
    <Icon>
      <circle cx="9" cy="8" r="3" />
      <path d="M4 18a4 4 0 0 1 .3-8 5 5 0 0 1 9.6-1.8A4.5 4.5 0 0 1 19 18H4Z" />
    </Icon>
  );
}
